<template>
  <div>
    <div v-for="(item, i) in drugShowList.slice(0, 2)" :key="i" class="drug_wrap">
      <div class="row_wrap">
        <div class="left_text">
          <span v-if="item.index === 0">
            {{ getKeyValueText('drug_use_time', item.useDrugTime) }}
          </span>
          <span
            v-if="
              item.isDrugInducer && item.isDrugInducer !== '0' && item.isDrugInducer !== 'false'
            "
            class="inducer"
          >
            
          </span>
        </div>
        <div class="right_text">
          <span v-if="item.index === 0" class="colon">:</span>
          <span class="colon">{{ item.drugName }}</span>
          <span>
            {{
              item.drugSpec +
              ' × ' +
              item.amount +
              ' ' +
              getKeyValueText('package_unit_meng', item.packageUnit)
            }}
          </span>
        </div>
      </div>
      <div class="row_wrap">
        <div class="left_text" />
        <div class="right_text right_pad">
          <span class="colon">
            {{
              item.useAuantity +
              ' ' +
              getKeyValueText('measure_unit_meng', item.measureUnit) +
              ' × ' +
              item.useDays +
              '  '
            }}
          </span>
          <span class="colon">
            {{ getKeyValueText('drug_usage_meng_his', item.drugUsage) }}
          </span>
        </div>
      </div>
      <div v-if="item.attention" class="row_wrap">
        <div class="left_text">
          <span>嘱托</span>
        </div>
        <div class="right_text">
          <span class="colon">:</span>
          <span class="colon">{{ item.attention }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  props: {
    drugList: {
      type: [Array],
      default: () => {
        return []
      }
    },
    allInBool: {
      type: Boolean,
      default: true
    },
    templateType: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      arr: [],
      drugShowList: []
    }
  },
  watch: {
    drugList: {
      handler(val) {
        this.drugShowList = this.handleList(val, 'useDrugTime')
      },
      immediate: true
    },
    allInBool: {
      handler(val) {},
      immediate: true
    },
    templateType: {
      handler(val) {}
    }
  },
  methods: {
    getKeyValueText,
    groupBy(arr, key) {
      const obj = {}
      arr.sort((a, b) => a[key] - b[key])
      arr.map(item => {
        const _key = item[key]
        if (obj[_key]) {
          obj[_key].push(item)
        } else {
          obj[_key] = [item]
        }
      })
      return obj
    },
    handleList(val) {
      this.arr = val.filter(item => {
        return item.drugID
      })
      const groupObj = this.groupBy(this.arr, 'useDrugTime')
      let finArr = []
      for (const i in groupObj) {
        finArr.push(groupObj[i])
      }

      finArr = finArr.map((item, i) => {
        item.sort((a, b) => a.isDrugInducer - b.isDrugInducer)
        item.map((item2, index2) => {
          item2.index = index2
          return item2
        })
        return item
      })

      return [].concat(...finArr)
    }
  }
}
</script>

<style lang="scss" scoped>
view,
text {
  font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun;
}
.drug_wrap {
  width: 100%;
  padding: 0.298667rem 0.298667rem 0 0.298667rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  // font-family: 'Courier New', Courier, monospace;
  // border-bottom: .021333rem solid #ececec;
  .row_wrap {
    display: flex;
    margin-bottom: 0.298667rem;
    position: relative;
    .left_text {
      min-width: 1.450667rem;

      .inducer {
        padding-left: 1em;
      }
    }
    .right_text {
      .colon {
        margin-right: 0.298667rem;
      }
      text {
        margin-right: 0.085333rem;
      }
    }
    .right_pad {
      padding-left: 0.64rem;
    }
    .delete_mdrug {
      position: absolute;
      right: 0.213333rem;
      top: 0.213333rem;
      z-index: 999;
      width: 1.024rem;
      height: 1.024rem;
    }

    .drug_name {
      font-size: 0.597333rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
      margin-right: 0.426667rem;
    }
    .specification,
    .drug_usage,
    .drug_usage_con,
    .entrust {
      font-size: 0.512rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.704rem;
      margin-right: 0.426667rem;
    }
    .amount {
      font-size: 0.597333rem;
    }
    .price {
      font-size: 0.512rem;
      font-weight: 400;
      color: #f86767;
      line-height: 0.704rem;
    }
    .entrust {
      color: #888;
    }
  }
}
</style>
